import { VERSION_LITE } from '@lib/constants';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { AUTH_ALREADY_HAVE_ACCOUNT, AUTH_LOGIN_IF_NO_ACCOUNT, HP_ANIMATIONS, HP_ANIMATION_TYPE } from '@lib/constants';

import { useI18n } from '@lib/i18n';
import { isKioskEnabled } from '@lib/kiosk';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function LoginHomepage() {
	const { t } = useI18n();

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
	? {
			'data-hp-trigger-selector': '',
			'data-hp-triggered-animation':
				HP_ANIMATION_TYPE,
			'data-hp-trigger-event':
				'viewport',
			'data-hp-triggered-played' : '0',
		}
	: {};

	const {
		authenticated,
		isOnline,
	} = useSelector((state) => state.user);

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if (authenticated) {
		return <></>;
	}

	if (!isOnline) {
		return <></>;
	}

	if (VERSION_LITE) {
		return <></>;
	}

	if (isKioskEnabled()) {
		return <></>;
	}

	return (
		<p className={`has-text-align-center mt-3 ${animationClass}`} {...animationData}>
			{t('home.already_have_account', AUTH_ALREADY_HAVE_ACCOUNT)}&nbsp;
			<Link className="has-text-weight-bold is-underlined" href="/auth/login">
				{t('home.login', AUTH_LOGIN_IF_NO_ACCOUNT)}
			</Link>
		</p>
	);
}
